<template>
  <footer class="w-footer">
    <div class="w-footer-left">
      <div class="w-footer-caption">
        <span>Данные сервера</span>
        <span class="w-version">версия {{ store.schedule.revision }}</span>
      </div>
      <ul class="w-log" aria-label="Последние действия">
        <li v-for="(entry, index) in lastEntries" :key="index">
          <time>{{ formatTime(entry.at) }}</time>
          <span>{{ store.lastName(entry.actorId) }}: {{ entry.message }}</span>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';

const LOG_SIZE = 3;

const store = useScheduleStore();

const lastEntries = computed(() => store.schedule.logs.slice(0, LOG_SIZE));

// Время действия — в часовом поясе филиала
const formatTime = (at: string) => new Date(at).toLocaleTimeString('ru-RU', {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: store.currentBranch?.timeZone || 'UTC',
});
</script>
